export enum ENUM_HISTORY_DATE_NAME {
  'general' = 'firm_general_history_date_filter',
  'claim' ='firm_claims_history_date_filter',
  'budget' ='firm_budgets_history_date_filter',
  'deliverynote' ='firm_deliverynotes_history_date_filter',
  'invoice' ='firm_invoices_history_date_filter',
  'invoiceproforma' ='firm_invoicesproforma_history_date_filter',
  'workorder' ='firm_workorders_history_date_filter',
}
